import { useState } from "react";
import { Loader2, LockKeyhole } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { api, formatApiError, inviteTokenKey } from "../lib/api";

export const PasswordPrompt = ({ slug, onUnlocked }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!password.trim()) return setError("Please enter the password");
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post(`/public/events/${slug}/unlock`, { password });
      localStorage.setItem(inviteTokenKey(slug), data.token);
      onUnlocked();
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="guest-password-prompt" className="rise mx-auto mt-6 max-w-sm rounded-3xl border border-slate-200 bg-white/95 p-8 text-center shadow-sm backdrop-blur">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-blue-50 text-blue-700">
        <LockKeyhole className="h-7 w-7" />
      </span>
      <h1 className="font-display mt-5 text-2xl font-extrabold tracking-tight text-slate-900">This invitation is password protected</h1>
      <p className="mt-2 text-sm text-slate-500">Enter the password from your host to open it.</p>
      <form onSubmit={submit} noValidate className="mt-6 space-y-3 text-left">
        <Input
          data-testid="guest-password-input"
          type="password"
          autoComplete="off"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="h-12 rounded-xl"
        />
        {error && <p data-testid="guest-password-error" className="text-xs font-semibold text-red-600">{error}</p>}
        <Button data-testid="guest-password-submit" type="submit" disabled={busy} className="h-12 w-full rounded-lg text-base font-semibold">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Open invitation"}
        </Button>
      </form>
    </section>
  );
};
